import { createSlice } from '@reduxjs/toolkit';

export const OUTBOUND_SMS_FEATURE = 'outboundSMS';
export const ROADSIDE_ASSISTANCE_FEATURE = 'roadside_assistance';

const initialState = {
  selectedFeature: null,
  tempMessage: null,
};

export const outboundSmsSlice = createSlice({
  name: 'outboundSms',
  initialState: initialState,
  reducers: {
    setSelectedFeature: (state, action) => {
      return {
        ...state,
        selectedFeature: action.payload,
      };
    },
    setTempMessage: (state, action) => {
      return {
        ...state,
        tempMessage: action.payload,
      };
    },
  },
});

export const { setSelectedFeature, setTempMessage } = outboundSmsSlice.actions;

export default outboundSmsSlice.reducer;
